var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Payload, UseCase } from "../../../../hooks/useUseCase";
import { drillApi } from "../../apis/DrillApi";
import { DRILL_TYPE_INFORMATION } from "../../constants/drill";
import { getDrillTypeIdsBySubjectId, isDrillTypeId, isSubjectId } from "../../utils/Drill";
import { FinishedLoadingPayload } from "./payload/FinishedLoadingPayload";
import { StartedLoadingPayload } from "./payload/StartedLoadingPayload";
import { WorkTemplateErrorPayload } from "./payload/WorkTemplateErrorPayload";
var InitializedPayload = /** @class */ (function (_super) {
    __extends(InitializedPayload, _super);
    function InitializedPayload(drillTypes, grade, subject, courseList, templateGroups) {
        var _this = _super.call(this) || this;
        _this.type = 'InitializedPayload';
        _this.drillTypes = drillTypes;
        _this.grade = grade;
        _this.subject = subject;
        _this.courseList = courseList;
        _this.templateGroups = templateGroups;
        return _this;
    }
    return InitializedPayload;
}(Payload));
export { InitializedPayload };
/**
 * 初期化
 */
var InitializeUseCase = /** @class */ (function (_super) {
    __extends(InitializeUseCase, _super);
    function InitializeUseCase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InitializeUseCase.prototype.execute = function (_a) {
        var _b;
        var selectionGrades = _a.selectionGrades, selectionSubjects = _a.selectionSubjects, templateGroups = _a.templateGroups, onChangeGrade = _a.onChangeGrade;
        return __awaiter(this, void 0, void 0, function () {
            var selectedTemplates, firstSelectedTemplate, grade, subject, drillTypes, courseList, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, 3, 4]);
                        this.dispatch(new StartedLoadingPayload());
                        selectedTemplates = templateGroups === null || templateGroups === void 0 ? void 0 : templateGroups.selectedTemplates;
                        firstSelectedTemplate = selectedTemplates != null && selectedTemplates.length > 0 ? selectedTemplates[0] : undefined;
                        grade = (_b = firstSelectedTemplate === null || firstSelectedTemplate === void 0 ? void 0 : firstSelectedTemplate.grade) !== null && _b !== void 0 ? _b : Number(selectionGrades[0].value);
                        subject = firstSelectedTemplate != null && isDrillTypeId(firstSelectedTemplate.drillType)
                            ? DRILL_TYPE_INFORMATION[firstSelectedTemplate.drillType].subjectId
                            : selectionSubjects[0].id;
                        if (!isSubjectId(subject)) {
                            return [2 /*return*/];
                        }
                        drillTypes = getDrillTypeIdsBySubjectId(subject, grade);
                        if (drillTypes.length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, drillApi.getCourseListWithKana()];
                    case 1:
                        courseList = _c.sent();
                        this.dispatch(new InitializedPayload(drillTypes, grade, subject, courseList, templateGroups));
                        onChangeGrade(grade);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _c.sent();
                        console.error("InitializeUseCase: \u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u30BF\u30D6\u306E\u521D\u671F\u5316\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002 " + error_1);
                        this.dispatch(new WorkTemplateErrorPayload());
                        return [3 /*break*/, 4];
                    case 3:
                        this.dispatch(new FinishedLoadingPayload());
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return InitializeUseCase;
}(UseCase));
export { InitializeUseCase };
